import apiClient from "./apiClient";

export const listRiskCategories = (params = {}) => apiClient.get("/risk-categories", { params });

export const createRiskCategory = (payload) => apiClient.post("/risk-categories", payload);

export const updateRiskCategory = (categoryId, payload) =>
  apiClient.patch(`/risk-categories/${categoryId}`, payload);

export const archiveRiskCategory = (categoryId) => apiClient.delete(`/risk-categories/${categoryId}`);
